import React from "react";
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles, Theme, createStyles, withStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepConnector from '@material-ui/core/StepConnector';
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';
import Button from "@material-ui/core/Button";
import { IAppPropsWithRoute } from '../../common/types';


interface HomePageProps extends IAppPropsWithRoute {
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            width: "100%",
            height: "100vh",
            backgroundColor: "#00152E",
        },
        container: {
            paddingTop: 40,
            paddingBottom: 40,
            backgroundColor: "#00152E",
        },
        label: {
            color: "#FFFFFF90",
            '&.MuiStepLabel-active': {
                color: "#FFF",
            },
            '&.MuiStepLabel-completed': {
                color: "#FFF",
            },
        },
        labelEdit: {
            color: "#FFF",
            '&.MuiStepLabel-active': {
                color: "#FFF",
            },
            '&.MuiStepLabel-completed': {
                color: "#FFF",
            },
        },
    })
);

const QontoConnectorWrapper = (isEdit: boolean) => {
    const QontoConnector = withStyles({
        alternativeLabel: {
            top: 10,
            left: 'calc(-50% + 16px)',
            right: 'calc(50% + 16px)',
        },
        active: {
            '& $line': {
                borderColor: '#FFF',
            },
        },
        completed: {
            '& $line': {
                borderColor: isEdit ? '#FFF' : '#4E9E73',
            },
        },
        line: {
            borderColor: isEdit ? '#FFF' : '#FFFFFF90',
            borderTopWidth: 3,
            borderRadius: 1,
            borderWidth: 2,
            marginTop: -6,
            marginBottom: -14,
        },
    })(StepConnector);
    return <QontoConnector />;
}


const useQontoStepIconStyles = makeStyles({
    root: {
        color: '#FFFFFF90',
        display: 'flex',
        height: 22,
        alignItems: 'center',
        marginLeft: 9
    },
    active: {
        color: '#FFF',
    },
    circle: {
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: 'currentColor',
    },
    completed: {
        color: '#4E9E73',
        zIndex: 1,
        fontSize: 18,
        marginLeft: -5
    },
});



const QontoStepIcon = (props: any) => {
    const classes = useQontoStepIconStyles();
    const { active, completed, isEdit } = props;

    return (
        <div
            className={clsx(classes.root, {
                [classes.active]: active,
            })}
            style={{ paddingRight: 10 }}
        >
            {completed && !isEdit ? <CheckCircleRoundedIcon className={classes.completed} /> : <div className={classes.circle} />}
        </div>
    );
}

QontoStepIcon.propTypes = {
    /**
     * Whether this step is active.
     */
    active: PropTypes.bool,
    /**
     * Mark the step as completed. Is passed to child components.
     */
    completed: PropTypes.bool,
};

const CancelButton = withStyles({
    root: {
        boxShadow: 'none',
        textTransform: 'none',
        fontSize: 16,
        borderRadius: 6,
        width: 200,
        padding: '4px 50px',
        border: '1px solid',
        lineHeight: 1.5,
        color: "white",
        backgroundColor: '#000B19',
        borderColor: '#000B19',
        '&:hover': {
            backgroundColor: '#000B19A0',
        },
    },
})(Button);


const SaveButton = withStyles({
    root: {
        boxShadow: 'none',
        textTransform: 'none',
        fontSize: 16,
        borderRadius: 6,
        width: 200,
        padding: '4px 50px',
        border: '1px solid',
        lineHeight: 1.5,
        color: "white",
        backgroundColor: '#02489D',
        borderColor: '#02489D',
        '&:hover': {
            backgroundColor: '#02489D90',
        },
    },
})(Button);


export default function NavigationContainer({ steps, activeStep, setActiveStep, isEdit, saveChangesState, onCancel }: any) {
    const classes = useStyles();
  
 

    return (
        <div className={classes.root}>
            <Stepper
                activeStep={activeStep == 0 && !isEdit ? -1 : activeStep}
                orientation="vertical"
                className={classes.container}
                connector={isEdit ? <div style={{ height: 10 }}></div> : QontoConnectorWrapper(isEdit)}>

                {steps.map((label: any, index: any) => (
                    <Step key={label} onClick={() => {
                        if (index < activeStep || isEdit) {
                            if (window.document.getElementById('save_changes')) {
                                (window.document?.getElementById('save_changes'))?.click();
                            }
                            setTimeout(() => {setActiveStep(index)},0)
                        }
                    }} >

                        <StepLabel style={isEdit || index < activeStep ? { cursor: "pointer" } : {}} StepIconComponent={isEdit ? () => <></> : (props) => <QontoStepIcon {...props} isEdit={isEdit} />} classes={{ label: isEdit || index == activeStep ? classes.labelEdit : classes.label }}>{label}</StepLabel>
                    </Step>
                ))}

            </Stepper>
            <div style={{ alignSelf: "center", }}>
                {isEdit && <div style={{ alignSelf: "center", paddingBottom: 20 }}>
                    <SaveButton onClick={() => {
                        if (window.document.getElementById('update_changes')) {
                            (window.document?.getElementById('update_changes'))?.click();
                        } else {
                            saveChangesState[0]();
                        }
                    }} variant="contained">
                        Save Changes
                    </SaveButton>
                </div>}
                <div style={{ alignSelf: "center", paddingBottom: 30 }}>
                    <CancelButton onClick={onCancel} variant="contained">
                        Cancel
                    </CancelButton>
                </div>
            </div>
        </div>
    );
}
